export const RECEIVE_ROLE_DATA_HEALTH = "RECEIVE_ROLE_DATA_HEALTH"
export const GET_ROLE_DATA_HEALTH = "GET_ROLE_DATA_HEALTH"

export const receiveRoleDataHealth = (stats) => ({
  type: RECEIVE_ROLE_DATA_HEALTH,
  stats,
})

export const getRoleDataHealth = (success, error) => ({
  type: GET_ROLE_DATA_HEALTH,
  success,
  error,
})
